import axios from 'axios'
import CreateProgram from './dto/CreateProgram'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedProgramResultRequestDto} from './dto/PagedProgramResultRequestDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import GetAllPrograms from './dto/GetAllPrograms'
import UpdateProgram from './dto/UpdateProgram'
import GetProgram from './dto/GetProgram'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/Program/Create`
export const URL_DELETE = `${API_URL}/Program/Delete`
export const URL_GET = `${API_URL}/Program/Get`
export const URL_GET_ALL = `${API_URL}/Program/GetPagedAll`
export const URL_UPDATE = `${API_URL}/Program/Update`

export function onCreateProgram(createProgram: CreateProgram): Promise<boolean> {
  return axios.post(URL_CREATE, createProgram)
}

export function onDeleteProgram(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetProgram(entityDto: EntityDto): Promise<GetProgram> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetPagedAllPrograms(
  pagedFilterAndSortedRequest: PagedProgramResultRequestDto
): Promise<PagedResultDto<GetAllPrograms>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onUpdateProgram(updateProgramInput: UpdateProgram): Promise<boolean> {
  return axios.put(URL_UPDATE, updateProgramInput)
}
